import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const baseUrl = environment.baseUrl

@Injectable({
  providedIn: 'root'
})
export class PostpaidService {

  constructor(
    private http: HttpClient
  ) { }

  getMyPostpaidList(filters): Observable<any> {
    let params = new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.get<any>(`${baseUrl}/finance/postpaid/`, { params })
  }

  addPostpaid(postpaidId, filters): Observable<any> {
    let params = new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.put<any>(`${baseUrl}/finance/postpaid/${postpaidId}/`, params)
  }

  customerPostpaidPaymentList(postpaidId, parameters): Observable<any> {
    let params = new HttpParams;
    for (let param in parameters) {
      if (parameters[param]) {
        params = params.append(param, parameters[param])
      }
    }
    return this.http.get<any>(`${baseUrl}/finance/postpaid/${postpaidId}/payments/`, { params })
  }

  postpaidPaymentListByAdmin(postpaidId, parameters): Observable<any> {
    let params = new HttpParams;
    for (let param in parameters) {
      if (parameters[param]) {
        params = params.append(param, parameters[param])
      }
    }
    return this.http.get<any>(`${baseUrl}/reports/panel/postpaid-company/${postpaidId}/payments/`, { params })
  }

  adminPostpaidPaymentList(parameters): Observable<any> {
    let params = new HttpParams;
    for (let param in parameters) {
      if (parameters[param]) {
        params = params.append(param, parameters[param])
      }
    }
    return this.http.get<any>(`${baseUrl}/reports/panel/postpaid-company/customers-payments/`, { params })
  }

  getPostpaidCompanyList(parameters): Observable<any> {
    let params = new HttpParams;
    for (let param in parameters) {
      if (parameters[param]) {
        params = params.append(param, parameters[param])
      }
    }
    return this.http.get<any>(`${baseUrl}/reports/panel/postpaid-company/`, { params })
  }

  getPostpaidCompanyDetail(id): Observable<any> {
    return this.http.get<any>(`${baseUrl}/reports/panel/postpaid-company/${id}/`)
  }

  createPostpaidCompany(parameters): Observable<any> {
    let params = new HttpParams;
    for (let param in parameters) {
      if (parameters[param]) {
        params = params.append(param, parameters[param])
      }
    }
    return this.http.post<any>(`${baseUrl}/reports/panel/postpaid-company/`, params)
  }


  customerPostpaidInvoiceList(postpaidId, parameters): Observable<any> {
    let params = new HttpParams;
    for (let param in parameters) {
      if (parameters[param]) {
        params = params.append(param, parameters[param])
      }
    }
    return this.http.get<any>(`${baseUrl}/finance/postpaid/${postpaidId}/invoices/`, { params })
  }

  adminPostpaidInvoiceList(postpaidId, parameters): Observable<any> {
    let params = new HttpParams;
    for (let param in parameters) {
      if (parameters[param]) {
        params = params.append(param, parameters[param])
      }
    }
    return this.http.get<any>(`${baseUrl}/reports/panel/postpaid-company/${postpaidId}/invoices/`, { params })
  }

  adminCustomersPostpaidInvoiceList(parameters): Observable<any> {
    let params = new HttpParams;
    for (let param in parameters) {
      if (parameters[param]) {
        params = params.append(param, parameters[param])
      }
    }
    return this.http.get<any>(`${baseUrl}/reports/panel/postpaid-company/customers-invoices/`, { params })
  }

  getInvoiceDetail(id): Observable<any> {
    return this.http.get<any>(`${baseUrl}/finance/ach-invoice/${id}/`)
  }

  getMyPaymentMethodDetail(id): Observable<any> {
    return this.http.get<any>(`${baseUrl}/finance/payment-method/${id}/`)
  }

  getAdminCustomerCards(postpaidId, paymentMethodId): Observable<any> {
    return this.http.get<any>(`${baseUrl}/finance/admin-customer-cards/${postpaidId}/${paymentMethodId}/`);
  }

  adminUpdateCustomerCard(postpaidId, paymentMethodId, parameters): Observable<any> {
    let params = new HttpParams;
    for (let param in parameters) {
      if (parameters[param]) {
        params = params.append(param, parameters[param])
      }
    }
    return this.http.put<any>(`${baseUrl}/finance/admin-customer-cards/${postpaidId}/${paymentMethodId}/`, params);
  }

  activeOrDeactivePostpaidCompany(id): Observable<any> {
    return this.http.put<any>(`${baseUrl}/reports/panel/postpaid-company/${id}/`, {})
  }

  getPostpaidStatements(parameters?): Observable<any> {
    let params = new HttpParams;
    for (let param in parameters) {
      if (parameters[param]) {
        params = params.append(param, parameters[param])
      }
    }
    return this.http.get<any>(`${baseUrl}/reports/panel/postpaid-company/statement/`, { params })
  }

  getCustomersPostpaidStatement(parameters, id): Observable<any> {
    let params = new HttpParams;
    for (let param in parameters) {
      if (parameters[param]) {
        params = params.append(param, parameters[param])
      }
    }
    return this.http.get<any>(`${baseUrl}/reports/panel/postpaid-company/${id}/customers-statement/`, { params })
  }

}
